import { createRouter, createWebHashHistory } from 'vue-router'
import OrganizationsList from '../views/organisatons_list'
import PaymentsList from '../views/payments'
import PlanEdit from '../views/plan_edit'
import Main from '../views/main'
import DocumentsTemplatesList from '../views/documents/templates_list'
import DocumentsTemplatesEdit from '../views/documents/template_edit'
import BillsList from '../views/bills/bills_list'
import BillEdit from '../views/bills/bill_edit'
import ManagerOrg from '../views/manager_org'

const routes = [
  {
    path: '/main/',
    name: 'main',
    component: Main
  },
  {
    path: '/organisations/list/',
    name: 'organistations_list',
    component: OrganizationsList
  },
  {
    path: '/manager/org/',
    name: 'manager_org',
    component: ManagerOrg
  },
  {
    path: '/payments/list/',
    name: 'payments',
    component: PaymentsList
  },
  {
    path: '/plans/edit/',
    name: 'plan_edit',
    component: PlanEdit
  },
  {
    path: '/documents/',
    name: 'documents_list',
    component: DocumentsTemplatesList
  },
  {
    path: '/documents/create/',
    name: 'documents_template_create',
    component: DocumentsTemplatesEdit
  },
  {
    path: '/documents/edit/:id',
    name: 'documents_template_edit',
    component: DocumentsTemplatesEdit,
    props: true
  },
  {
    path: '/bills/',
    name: 'bills_list',
    component: BillsList
  },
  {
    path: '/bills/edit/:id',
    name: 'bill_edit',
    component: BillEdit,
    props: true
  }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router
